import Stepper from "components/Stepper";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import NewLogo from "assets/icons/new_logo.svg?react";
import HollowButton from "components/HollowButton";
import { useMediaQuery } from "usehooks-ts";
import HorizontalStepper from "components/HorizontalStepper";

const AuthLayout: FC<Props> = ({
  steps,
  actualStep,
  backLabel,
  handleBack,
  children,
  footerChildren,
}) => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  return (
    <div className={styles.wrapper}>
      {!isMobile && (
        <div className={styles.leftBar}>
          <NewLogo className={styles.logo} />
          <Stepper steps={steps} actualStep={actualStep} />

          <div className={styles.footer}>
            {handleBack && (
              <HollowButton
                text={backLabel}
                onClick={() => handleBack?.()}
              ></HollowButton>
            )}
            {footerChildren}
          </div>
        </div>
      )}
      <div className={styles.content}>
        {children}

        {isMobile && (
          <div className={styles.mobileStepper}>
            <HorizontalStepper steps={steps} actualStep={actualStep} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthLayout;
